export const MenuItemValues = {
    Edit: 1,
    AddNode: 2,
    AddTom: 3,
    Delete: 4,
    AddAct: 5,
    AddActDocument: 6
}